import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs';
import { RoutePath } from './enums/route-path.enum';
import { UserProfileService } from './pages/services/user-profile.service';
import { UserProfile } from './pages/user-profile/models/user-profile';
import { CustomerProfileService } from './pages/services/customer-profile.service';
import { AnalysesRequestService } from './pages/rdp/services/analyses-request.service';
import { PointAndClickService } from './pages/point-&-click/services/point-and-click.service';

@Injectable({
  providedIn: 'root',
})
export class FirstLoginGuard implements CanActivate, CanActivateChild {
  constructor(
    private customerProfileService: CustomerProfileService,
    private router: Router,
    private analysesRequestService: AnalysesRequestService,
    private pointAndClickService: PointAndClickService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canProceed(next);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(childRoute, state);
  }

  canProceed(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.customerProfileService.getMyProfile().pipe(
      map((profile: UserProfile) => {
        if (
          (profile.luEdited != null && profile.luEdited) ||
          !profile.canEditProfile
        ) {
          // return true;

          // Controllo se l'utente ha già firmato almeno un contratto PointAndClick per Rdp
          // IF: ho almeno un contratto firmato allora rimando alla pagina base
          // if (this.analysesRequestService.isAnalysesRequestWithSignedContract(profile.id, profile.society)) {
          return true;
          // }
          //  ELSE: applico la guard e blocco su user-profile
        }

        return this.router.createUrlTree([RoutePath.USER_PROFILE]);
      }),
    );
  }
}
